export default __webpack_public_path__ + "static/media/Takeaway_Completed.10e792fc.svg";